import { Component, Input } from '@angular/core';

import { ActivityLogData } from 'src/app/interfaces/activity.interface';

@Component({
  selector: 'app-activities-removed',
  templateUrl: './activities-removed.component.html',
  styleUrls: ['./activities-removed.component.scss'],
})
export class ActivitiesRemovedComponent {
  @Input({ required: true }) public activeUserId: string;
  @Input({ required: true }) public data: ActivityLogData;
}
